import CircleType from 'circletype/dist/circletype.min';
require('../scss/front-page.scss');
import './animations/fp-carousel-showcase';
import './animations/fp-carousel-testimonial';

//Animations
import './animations/fp-sea';

//Images
import '../image/flourish.png';
import '../image/starburst.png';
import '../image/sky-bg.png';
import '../image/all-fish.svg';
import '../image/testimonials-banner.png';

//Function to Run Animation after SVGS are injected
$(document).ready(function() {
	//FitText - Intro Headline
	if ($('.headline-super').length) {
		$('#fp-intro-headline > .fit-top').fitText(.8, {
			maxFontSize: '72px'
		});
		$('#fp-intro-headline > .fit-bottom').fitText(1, {
			maxFontSize: '48px'
		});
	}

	// CircleText + FitText - Buckets Headline
	const sub1 = document.getElementById('sub-1');
	if ($(sub1).length) {
		new CircleType(sub1)
			.radius(250);
	}

	const sub2 = document.getElementById('sub-2');
	if ($(sub2).length) {
		new CircleType(sub2)
			.radius(250);
	}

	const sub3 = document.getElementById('sub-3');
	if ($(sub3).length) {
		new CircleType(sub3)
			.radius(250);
	}

	if (jQuery('.bucket .subheading').length) {
		$('.bucket .subheading').fitText(2, {
			maxFontSize: '32px'
		});
	}
});